import { useQuery } from '@zg-rentals/react-query5';
import { HpApiSearchV3Handler_filterMetadata_queryOptions } from '@zg-rentals/ts-hotpads-api-client-react-query';
import type { HpApiResponseDto, HpFilterMetadataResponseDto } from '@zg-rentals/ts-hotpads-api-client';

import { filterMetadataKeys } from './queryKeys';

const FILTER_METADATA_STALE_TIME = 5 * 60 * 1000;

function selectFilterMetadata(response: HpApiResponseDto<HpFilterMetadataResponseDto>): HpFilterMetadataResponseDto {
  if (response.error) {
    throw new Error(`filter metadata failed: ${JSON.stringify(response.error)}`);
  }
  if (!response.data) {
    throw new Error('filter metadata response has no data');
  }
  return response.data;
}

export function useFilterMetadata() {
  return useQuery({
    ...HpApiSearchV3Handler_filterMetadata_queryOptions(),
    queryKey: filterMetadataKeys.all,
    staleTime: FILTER_METADATA_STALE_TIME,
    select: selectFilterMetadata,
    meta: {
      tags: ['filter-metadata'],
      context: {
        api: 'hotpads-api',
        details: 'V3 search filter metadata',
      },
    },
  });
}
